export const occupancyModeOptions = [
  {
    value: "independent_owner",
    label: "Independent professional rental",
    description:
      "Use this when the renter runs their own business in your salon workspace and keeps their own client relationship.",
  },
];

export const clientOwnershipOptions = [
  {
    value: "independent_owned",
    label: "Independent professional owned",
    description:
      "The independent professional keeps the client relationship while the salon only sees support details needed for work performed at that location.",
  },
];

export const approvalModeOptions = [
  { value: "manual", label: "Manual review" },
  { value: "automatic", label: "Automatic approval" },
  { value: "agreement_required", label: "Agreement required" },
];

export const rentModelOptions = [
  { value: "flat_rent", label: "Flat rent" },
  { value: "percentage", label: "Percentage" },
  { value: "hybrid", label: "Hybrid / mixed" },
];

export const controlOptions = [
  { value: "salon", label: "Salon" },
  { value: "renter", label: "Independent renter" },
  { value: "shared", label: "Shared" },
];

export const productProviderOptions = [
  { value: "salon", label: "Salon only" },
  { value: "renter", label: "Renter only" },
  { value: "shared", label: "Shared / mixed" },
];

export const paymentCollectorOptions = [
  { value: "salon", label: "Salon" },
  { value: "renter", label: "Independent renter" },
  { value: "platform", label: "Platform / marketplace" },
];

export const agreementKindOptions = [
  { value: "lease", label: "Lease" },
  { value: "booking", label: "Booking terms" },
  { value: "workspace", label: "Workspace terms" },
];

export function titleCaseComplianceLabel(value, fallback = "Not set") {
  const normalized = String(value || "").trim();
  if (!normalized) return fallback;
  return normalized
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

export function getWarningTone(level) {
  const normalized = String(level || "").trim().toLowerCase();
  if (normalized === "high" || normalized === "high_risk") {
    return "border-rose-200 bg-rose-50 text-rose-800";
  }
  if (normalized === "medium" || normalized === "warning") {
    return "border-amber-200 bg-amber-50 text-amber-800";
  }
  return "border-sky-200 bg-sky-50 text-sky-800";
}
